<template>
  <div class="app-container">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClicktab">
        <el-tab-pane label="待确认" name="first">
          <div class="formBox margbot" ref="searchBox">
            <el-form :inline="true" :model="formData" label-width="110px" size="mini" >
              <div class="formItemBox">
              <el-form-item label="入库单号:">
                <el-input  v-model="formData.instockNo" placeholder="请输入入库单号" size="mini"
                 ></el-input>
              </el-form-item>
              <el-form-item label="车号:">
                <el-input  v-model="formData.instockPlateNumber" placeholder="请输入车号" size="mini"
                 ></el-input>
              </el-form-item>
              <el-form-item label="一级货主:">
                <el-select size="mini" filterable clearable placeholder="请选择一级货主"
                  v-model="formData.primaryCustomerTaxId">
                  <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName"
                    :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级货主:">
                <el-select size="mini" clearable filterable placeholder="请选择二级货主" v-model="formData.customerTaxId">
                  <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName"
                    :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:">
                <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择"
                  filterable size="mini">
                  <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                    :value="item.productType">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产地:">
                <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择"
                  filterable size="mini">
                  <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="规格:">
                <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择"
                  filterable size="mini">
                  <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="材质:">
                <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable
                  size="mini">
                  <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="入库时间:">
                <div style="display: flex;">
                <el-date-picker v-model="formData.instockTimeStart" size="mini" type="datetime" placeholder="选择入库日期"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                -
                <el-date-picker v-model="formData.instockTimeEnd" size="mini" placeholder="选择入库日期" type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="到货方式:">
                <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
                  <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车船号:">
                <el-input class="ipt" v-model.trim="formData.plateNumber" placeholder="请输入车船号" size="mini"
                 ></el-input>
              </el-form-item>
             </div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP003B001" v-if="btnFlg[0]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP003B002" v-if="btnFlg[1]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochu" btnCode="00cP003B003" v-if="btnFlg[2]">导出
                </el-button>
                <!-- 2022年1月6日项目经理要求去掉4个按钮 原型没有周口店有-->
                <!-- <el-button type="primary" size="mini" @click="importFn" btnCode="00ZP003B004">导入客户</el-button> -->
                <!-- <el-button type="primary" size="mini" @click="xiugai" btnCode="00ZP003B005" >修改客户</el-button> -->
                <!-- <el-button type="primary" size="mini" @click="chaibao" btnCode="00ZP003B006" >拆包</el-button> -->
                <!-- <el-button type="primary" size="mini" @click="hebao" btnCode="00ZP003B00C">合包</el-button> -->
                <el-button type="primary" size="mini" @click="QRjincang" btnCode="00cP003B004" v-if="btnFlg[3]">进仓确认
                </el-button>
              </el-form-item>
              <el-form-item>
                <span>
                  总吨数:
                  <span style="color: red">{{Number(totalAllWeight).toFixed(4)}}</span> &nbsp;吨
                </span>
                <span style="margin-left: 15px">
                  总件数:
                  <span style="color: red">{{ totalNumber }}</span> &nbsp;件
                </span>&nbsp;&nbsp;&nbsp;
                <span>已选中总吨数:
                  <span style="color:red">{{seleteWeight}}</span>&nbsp;吨
                </span>&nbsp;&nbsp;&nbsp;&nbsp;
                <span>已选中总件数:
                  <span style="color:red">{{ seleteNumber }}</span>&nbsp;件
                </span>
              </el-form-item>
            </el-form>
          </div>
          <div :style="{height:h}">
            <el-table border center bordersize="mini" :data="tableData" height="100%" style="width:100%" size="mini"
              ref='tableRef' highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              @selection-change="selectGoods" @row-click='handleRow'>
              <el-table-column type="selection" align="center" width="40" fixed></el-table-column>
              <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockTime" label="入库时间" width="180">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车船号" align="center" width="130">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="250">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="250">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重（吨）" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="过磅净重时间" width="180">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createUser" label="入库人" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="shipForecastNo" label="预报编号" align="center"
                width="200"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center"
                width="130"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center" width="150">
              </el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
              :page-size="pageInfo.pageSize" :page-sizes="[10,30,50,100,500]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已确认" name="second">
          <div class="formBox margbot" ref="searchBoxT">
            <el-form :inline="true" :model="formDataTwo" label-width="100px" size="mini">
              <div class="formItemBox">
              <el-form-item label="入库单号:">
                <el-input class="ipt" v-model="formDataTwo.instockNo" placeholder="请输入入库单号" size="mini"
                 ></el-input>
              </el-form-item>
              <el-form-item label="车号:">
                <el-input class="ipt" v-model="formDataTwo.instockPlateNumber" placeholder="请输入车号" size="mini"
                  ></el-input>
              </el-form-item>
              <el-form-item label="进仓单号:">
                <el-input class="ipt" v-model="formDataTwo.inWarehouseNo" placeholder="请输入进仓单号" size="mini"
                 ></el-input>
              </el-form-item>
              <el-form-item label="一级货主:">
                <el-select size="mini" filterable clearable placeholder="请选择一级货主"
                  v-model="formDataTwo.primaryCustomerTaxId">
                  <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName"
                    :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级货主:">
                <el-select size="mini" clearable filterable placeholder="请选择二级货主" v-model="formDataTwo.customerTaxId">
                  <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName"
                    :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="确认时间:">
                <div style="display: flex;">
                <el-date-picker v-model="formDataTwo.confirmTimeStart" size="mini" type="datetime" placeholder="选择确认时间"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                -
                <el-date-picker v-model="formDataTwo.confirmTimeEnd" size="mini" placeholder="选择确认时间" type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="货物类型:">
                <el-select v-model="formDataTwo.productType" clearable @change="productTypeChange1" placeholder="请选择"
                  filterable size="mini">
                  <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                    :value="item.productType">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产地:">
                <el-select v-model="formDataTwo.steelMillName" @change='steelMillNameChange1' clearable
                  placeholder="请选择" filterable size="mini">
                  <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="规格:">
                <el-select v-model="formDataTwo.specification" clearable @change='specificationChange1'
                  placeholder="请选择" filterable size="mini">
                  <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="材质:">
                <el-select v-model="formDataTwo.model" @change="modelChange1" clearable placeholder="请选择" filterable
                  size="mini">
                  <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="到货方式:">
                <el-select v-model="formDataTwo.arrivalMethod" clearable placeholder="请选择" filterable size="mini">
                  <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车船号:">
                <el-input class="ipt" v-model.trim="formDataTwo.plateNumber" placeholder="请输入车船号" size="mini"
                  ></el-input>
              </el-form-item>
              </div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxunT" btnCode="00cP003B005" v-if="btnFlg[4]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhiT" btnCode="00cP003B006" v-if="btnFlg[5]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochuT" btnCode="00cP003B007" v-if="btnFlg[6]">导出
                </el-button>
                <el-button type="primary" size="mini" @click="xiugaiT" btnCode="00cP003B008" v-if="btnFlg[7]">修改进仓单
                </el-button>
              </el-form-item>
              <el-form-item>
              <span>
                总吨数:
                <span style="color: red">{{Number(totalAllWeightB).toFixed(4)}}</span> &nbsp;吨
              </span>
              <span style="margin-left: 15px">
                总件数:
                <span style="color: red">{{ totalNumberB }}</span> &nbsp;件
              </span>
            </el-form-item>
            </el-form>
          </div>
          <div :style="{height:H}">
            <el-table border center bordersize="mini" :data="tableDataT" height="100%" style="width:100%" size="mini"
              ref="QRTable" @selection-change="selectGoods" @row-click='handleRow1'>
              <el-table-column type="selection" align="center" width="40"></el-table-column>
              <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
              <el-table-column width="80" label="操作" align="center">
                <template v-slot='scope'>
                  <el-button type="text" @click="editRecord(scope.$index,scope.row)">修改记录</el-button>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="confirmTime" label="确认时间" width="180">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="inWarehouseNo" label="进仓单号" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockTime" label="入库时间" width="180">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车船号" align="center" width="130">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="250">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="250">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量(吨)" width="110">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重(吨)" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="过磅净重时间" width="180">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重(吨)" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="shipForecastNo" label="预报编号" align="center"
                width="200"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center"
                width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="confirmName" label="确认人" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="stockConfirmId" label="ID" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center" width="150">
              </el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChangeT" :current-page="pageInfoT.pageNo"
              :page-size="pageInfoT.pageSize" :page-sizes="[10,30,50,100,500]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeT" :total="totalT">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 进仓确认 -->
    <div>
      <el-dialog title="进仓确认" :visible.sync="dialogVisiblejincang" :close-on-click-modal="false"
        @close="dialogVisiblejincang=false" width="40%" center>
        <!--form表单-->
        <el-form :model="xiugaiFormData" ref="xiugaiFormData" label-width="100px" class="demo-dynamic"
          style="width:350px;margin:30px auto;">
          <el-form-item prop="inWarehouseNo" label="进仓单号" :rules="[
              { required: true, message: '请输入进仓单号', trigger: 'blur' },
            ]">
            <el-input size="mini" v-model="xiugaiFormData.inWarehouseNo" style="width:193px;"></el-input>
          </el-form-item>
        </el-form>
        <div style="width:180px;margin:15px auto;">
          <el-button @click="dialogVisiblejincang = false">取 消</el-button>
          <el-button type="primary" @click="jincangQR()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 拆包 -->
    <div class="shenhe">
      <el-dialog title="拆包" :visible.sync="CBVisible" :close-on-click-modal="false" width="90%" center=""
        @close='closeCB'>
        <el-table height="100%" border bordersize="mini" size="mini" ref="tabref" :data="subTableData"
          style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}"
          :header-cell-class-name="Add">
          <el-table-column prop="unpackingNumber" label="拆包件数" width="120px">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.unpackingNumber" maxlength="50" placeholder="请输入件数" size="mini"
                @input="NumberInput(scope1.row)" v-number-input.float="0"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="unpackingWeight" label="拆包理重（吨）" width="150px">
            <template slot-scope="scope1">
              <el-input v-model="scope1.row.unpackingWeight" maxlength="50" placeholder="请输入理重(吨)" size="mini"
                :disabled="true"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="unpackingPoundWeight" label="拆包磅重（吨）" width="150px">
            <template slot-scope="scope1">
              <el-input v-number-input.float="4" v-model="scope1.row.unpackingPoundWeight" maxlength="50"
                placeholder="请输入磅重(吨)" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="unpackingFactoryPoundWeight" label="拆包出厂过磅净重（吨）" width="200px">
            <template slot-scope="scope1">
              <el-input v-number-input.float="4" v-model="scope1.row.unpackingFactoryPoundWeight" maxlength="50"
                placeholder="请输入出厂过磅净重(吨)" size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="件数" width="120px"></el-table-column>
          <el-table-column prop="allWeight" label="总重量（吨）" width="120px"></el-table-column>
          <el-table-column prop="weight" label="理重（吨）" width="120px"></el-table-column>
          <el-table-column prop="poundWeight" label="过磅净重（吨）" width="120px"></el-table-column>
          <el-table-column prop="factoryWeight" label="出厂过磅净重（吨）" width="150px"></el-table-column>
          <el-table-column prop="instockTime" label="入库时间" width="200px"></el-table-column>
          <el-table-column prop="instockNo" label="入库单号" width="220px"></el-table-column>
          <el-table-column prop="instockPlateNumber" label="车号" width="120px"></el-table-column>
          <el-table-column prop="primaryCustomerName" label="一级货主" width="250px"></el-table-column>
          <el-table-column prop="customerName" label="二级货主" width="250px"></el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" width="120px"></el-table-column>
          <el-table-column prop="steelMillName" label="产地" width="250px"></el-table-column>
          <el-table-column prop="specification" label="规格" width="120px"></el-table-column>
          <el-table-column prop="model" label="材质" width="120px"></el-table-column>
          <el-table-column prop="warehouseName" label="仓位" width="120px"></el-table-column>
        </el-table>
        <div style="width: 180px; margin: 15px auto">
          <el-button @click="closeCB">取 消</el-button>
          <el-button type="primary" @click="succeCB" :loading='CBLoading'>保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改客户 -->
    <div>
      <el-dialog title="修改客户" :visible.sync="XGvisible" :close-on-click-modal="false" @close="XGvisible=false"
        width="40%" center>
        <!--form表单-->
        <el-form :model="KHFormData" ref="KHFormData" label-width="100px" class="demo-dynamic"
          style="width:350px;margin:30px auto;">
          <el-form-item prop="modifyBefore" label="原客户：">{{ oldcustomer }}</el-form-item>
          <el-form-item prop="modifyAfter" label="新客户：" :rules="[
              { required: true, message: '请选择新客户', trigger: 'change' },
            ]">
            <el-select size="mini" filterable clearable placeholder="请选择新客户" v-model="KHFormData.modifyAfter"
              ref="selectProvinces" @visible-change='isShowSelectOptions'>
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="width:150px;margin:15px auto;">
          <el-button @click="XGvisible = false">取 消</el-button>
          <el-button type="primary" @click="XGQD()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改进仓单号 -->
    <div>
      <el-dialog title="修改进仓单号" :visible.sync="XGDHvisible" :close-on-click-modal="false" @close="XGDHvisible=false"
        width="40%" center>
        <!--form表单-->
        <el-form :model="DHFormData" ref="DHFormData" label-width="150px" class="demo-dynamic"
          style="width:350px;margin:30px auto;">
          <el-form-item prop="modifyBefore" label="原进仓单号：">{{ oldDH }}</el-form-item>
          <el-form-item prop="modifyAfter" label="新进仓单号：" :rules="[
              { required: true, message: '请输入进仓单号', trigger: 'blur' },
            ]">
            <el-input size="mini" v-model.trim="DHFormData.modifyAfter" style="width:193px;"></el-input>
          </el-form-item>
        </el-form>
        <div style="width:200px;margin:15px auto;">
          <el-button @click="XGDHvisible = false">取 消</el-button>
          <el-button type="primary" @click="XGDH()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改记录 -->
    <div>
      <el-dialog title="修改记录" :visible.sync="XGJLVisible" :close-on-click-modal="false" width="50%" center=""
        @close='closeXGJL'>
        <el-table height="100%" border bordersize="mini" size="mini" ref="tabref" :data="XGRecordData"
          style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column prop="modifyBefore" label="修改前"></el-table-column>
          <el-table-column prop="modifyAfter" label="修改后"></el-table-column>
          <el-table-column prop="createUser" label="修改人"></el-table-column>
          <el-table-column prop="createTime" label="修改时间" :formatter="dateTimeFormat"></el-table-column>
        </el-table>
        <div style="width: 100px; margin: 15px auto">
          <el-button @click="closeXGJL" type="primary">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
    <!--点击导入按钮弹出框-->
    <div class="addMarkBox" custom-class="el-dialog--center" v-if="daoruMark">
      <el-dialog @close="closeDialogFile" title="导入" :visible.sync="daoruMark" :close-on-click-modal="false" width="40%"
        center>
        <div style="margin: 15px auto" class="el-dialog--center">
          <input type="file" ref="file" accept=".xls, .csv, .xlsx" @change="getFile($event)" />
        </div>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="closeDialogFile">取消</el-button>
          <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  JfgetStockConfirmList,
  confirmToStrage,
  JfgetStockConfirmedList,
  JfstockConfirmUnpacking,
  JfimportStockConfirmList,
  JfmodifyStockConfirm,
  JfgetStorkConfirmedlList,
  JfstockConfirmPacking,
  jfGetStockConfirmNumber
} from '@/api/wms-access'
import {
  getRelationCustomer,
  getVirtualBalingList,
  getWeighingMethodList
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
export default {
  data () {
    return {
      DHFormData: {
        modifyAfter: '',
        modifyBefore: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      KHFormData: {
        modifyAfter: '',
        modifyBefore: ''
      },
      xiugaiFormData: {
        inWarehouseNo: ''
      },
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 30
      },
      total: 0,
      totalT: 0,
      pageInfoT: {
        pageNo: 1,
        pageSize: 30
      },
      formData: {
        instockNo: '',
        instockPlateNumber: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        instockTimeStart: '',
        instockTimeEnd: '',
        arrivalMethod: '',
        plateNumber: ''
      },
      btnArr: [
        '00cP003B001',
        '00cP003B002',
        '00cP003B003',
        '00cP003B004',
        '00cP003B005',
        '00cP003B006',
        '00cP003B007',
        '00cP003B008'
      ],
      btnFlg: [],
      formDataTwo: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        inWarehouseNo: '',
        confirmTimeStart: '',
        confirmTimeEnd: '',
        arrivalMethod: '',
        plateNumber: ''
      },
      tableDataT: [],
      tableData: [],
      HZData: [],
      SHData: [{
        value: 1,
        label: '同意'
      },
      {
        value: 2,
        label: '驳回'
      }
      ],
      h: 500,
      H: 500,
      CBVisible: false,
      CBLoading: false,
      shFormData: {
        auditResult: '',
        auditRemark: ''
      },
      shRules: {
        auditResult: [{
          required: true,
          message: '请选择审核结果',
          trigger: 'change'
        }],
        auditRemark: [{
          required: false,
          message: '请输入驳回原因',
          trigger: 'change'
        }]
      },
      xuanzhongArr: [],
      shenheYijian: '',
      dialogShenheVisible: false,
      lookApproverReject: false,
      dialogVisiblejincang: false,
      addLoad: false,
      isDisable1: false,
      XGvisible: false,
      XGDHvisible: false,
      selectListId: [],
      selectList: [],
      subTableData: [],
      oldcustomer: '',
      oldDH: '',
      XGJLVisible: false,
      XGRecordData: [],
      importDialog: false,
      daoruMark: false,
      file: null,
      totalAllWeight: 0,
      totalNumber: 0,
      arrivalMethodData: [{
        value: '1',
        label: '火运'
      },
      {
        value: '2',
        label: '汽运'
      },
      {
        value: '3',
        label: '船运'
      }
      ],
      totalAllWeightB: 0,
      totalNumberB: 0,
      seleteWeight: 0,
      seleteNumber: 0
    }
  },
  methods: {
    // 是否显示下拉框
    isShowSelectOptions (isShowSelectOptions) {
      if (!isShowSelectOptions) this.$refs.selectProvinces.blur()
    },
    // 小星星
    Add (obj) {
      if (this.subTableData[0].inWeighingMethod == 1) {
        if (obj.column.property == 'unpackingNumber' || obj.column.property == 'unpackingWeight') {
          return 'star'
        }
      }
      if (this.subTableData[0].inWeighingMethod == 2) {
        if (obj.column.property == 'unpackingPoundWeight' || obj.column.property == 'unpackingNumber' || obj.column
          .property == 'unpackingWeight') {
          return 'star'
        }
      }
      if (this.subTableData[0].inWeighingMethod == 3) {
        if (obj.column.property == 'unpackingFactoryPoundWeight' || obj.column.property == 'unpackingNumber' || obj
          .column.property == 'unpackingWeight') {
          return 'star'
        }
      }
    },
    handleRow (row) {
      this.$refs.tableRef.toggleRowSelection(row)
    },
    handleRow1 (row) {
      this.$refs.QRTable.toggleRowSelection(row)
    },
    // 点击导入
    importFn () {
      this.daoruMark = true
      this.file = []
    },
    closeDialogFile () {
      this.daoruMark = false
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    // 导入-确定
    daoruQueding (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        }
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      let name = extname(this.file.name)
      if (name == false) {
        DonMessage.error('文件为空,请选择文件进行导入')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') {
        DonMessage.error('请选择正确的文件格式')
      } else {
        let formData = new FormData()
        formData.append('file', this.file)
        this.isDisable1 = true
        JfimportStockConfirmList(formData)
          .then((res) => {
            // -1 提示错误信息， 0 成功， 1显示导出异常
            this.daoruMark = false
            this.isDisable1 = false
            this.$message({
              message: res,
              type: 'success'
            })
            this.JfgetStockConfirmLists()
          })
          .catch((err) => {
            if (err.code == -1) {
              this.$message({
                message: err.data == null ? err.message : err.data,
                type: 'error'
              })
            } else if (err.code == 1) {
              this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  const loading = this.$loading({
                    lock: true,
                    text: '正在导出异常信息...'
                  })
                  let form = {}
                  exportExcel(
                    this.global.wmsAccessName + '/instockThreadExp/exportStockConfirmExc',
                    form,
                    '导入记录异常表'
                  )
                  setTimeout(() => {
                    this.$message({
                      type: 'success',
                      message: '异常信息导出成功!'
                    })
                    loading.close()
                    this.JfgetStockConfirmLists()

                    this.daoruMark = false
                  }, 3000)
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消导出'
                  })
                })
            }
            this.isDisable1 = false
          })
      }
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
          console.log(this.productTypeData, 'this.productTypeData')
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 货物类型下拉框改变事件
    productTypeChange1 (val) {
      getVirtualBalingList({
        productType: this.formDataTwo.productType,
        placeOfOrigin: this.formDataTwo.steelMillName,
        specification: this.formDataTwo.specification,
        model: this.formDataTwo.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange1 (val) {
      getVirtualBalingList({
        productType: this.formDataTwo.productType,
        placeOfOrigin: this.formDataTwo.steelMillName,
        specification: this.formDataTwo.specification,
        model: this.formDataTwo.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange1 (val) {
      getVirtualBalingList({
        productType: this.formDataTwo.productType,
        placeOfOrigin: this.formDataTwo.steelMillName,
        specification: this.formDataTwo.specification,
        model: this.formDataTwo.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange1 (val) {
      getVirtualBalingList({
        productType: this.formDataTwo.productType,
        placeOfOrigin: this.formDataTwo.steelMillName,
        specification: this.formDataTwo.specification,
        model: this.formDataTwo.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 待确认查询
    JfgetStockConfirmLists () {
      JfgetStockConfirmList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        instockNo: this.formData.instockNo,
        instockPlateNumber: this.formData.instockPlateNumber,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        productType: this.formData.productType,
        steelMillName: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model,
        instockTimeStart: this.formData.instockTimeStart,
        instockTimeEnd: this.formData.instockTimeEnd,
        arrivalMethod: this.formData.arrivalMethod,
        plateNumber: this.formData.plateNumber
      })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.stockConfirmId) // id数组
        arry = Array.from(new Set(arry)) // 去重
      })
      this.selectListId = arry.join(',') // 获取全部货物id
      this.seleteWeight = selection.reduce((pre, cur) => {
        return pre / 1 + cur.allWeight / 1
      }, 0).toFixed(4)
      this.seleteNumber = selection.reduce((pre, cur) => {
        return pre / 1 + cur.number / 1
      }, 0)
    },
    // 点击进仓按钮
    QRjincang () {
      if (this.xuanzhongArr.length == 0) {
        this.xuanzhongArr = this.tableData[0]
      }
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行进仓操作！')
      } else {
        this.dialogVisiblejincang = true
        this.addLoad = false
        this.xiugaiFormData.inWarehouseNo = ''
        this.$nextTick(() => {
          this.$refs.xiugaiFormData.clearValidate()
        })
      }
    },
    // 进仓保存
    jincangQR () {
      this.addLoad = true
      this.$refs.xiugaiFormData.validate((valid) => {
        if (valid) {
          confirmToStrage({
            inWarehouseNo: this.xiugaiFormData.inWarehouseNo,
            idList: this.selectListId.split(',') // 主表id
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.addLoad = false
              this.dialogVisiblejincang = false
              this.chaxun()
            })
            .catch((err) => {
              DonMessage.error(err.message)
              this.addLoad = false
            })
        } else {
          this.addLoad = false
        }
      })
    },
    handleClicktab (tab, event) {
      this.chongzhi()
      this.chongzhiT()
      this.getHeight()
    },
    chaxun () {
      this.JfgetStockConfirmLists()
      this.getStockConfirmNumberJF()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.customerTaxId = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.instockTimeStart = ''
      this.formData.instockTimeEnd = ''
      this.formData.arrivalMethod = ''
      this.formData.plateNumber = ''
      this.JfgetStockConfirmLists()
      this.getVirtualBalingList()
      this.getStockConfirmNumberJF()
    },
    daochu () {
      exportExcel(
        this.global.wmsAccessName + '/instockThreadExp/exportStockConfirmList', {
          ...this.formData,
          instockStatus: '1'
        },
        '待确认表'
      )
    },
    xiugai () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else {
        this.XGvisible = true
        this.oldcustomer = this.selectList[0].customerName
        this.KHFormData.modifyAfter = ''
        this.$nextTick(() => {
          this.$refs.KHFormData.clearValidate()
        })
      }
    },
    // 修改客户
    XGQD () {
      this.addLoad = true
      this.$refs.KHFormData.validate((valid) => {
        if (valid) {
          this.KHFormData.customerName = this.HZData.filter(item => item.taxpayerNumber == this.KHFormData
            .modifyAfter)[0].custerName
          JfmodifyStockConfirm({
            stockConfirmIds: this.selectList[0].stockConfirmId,
            businessType: 1,
            modifyAfter: this.KHFormData.customerName,
            modifyAfterId: this.KHFormData.modifyAfter,
            modifyBeforeId: this.selectList[0].customerTaxId,
            modifyBefore: this.selectList[0].customerName
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.addLoad = false
              this.JfgetStockConfirmLists()
            })
            .catch((err) => {
              DonMessage.error(err.message)
              this.addLoad = false
            })
          this.XGvisible = false
        } else {
          this.addLoad = false
        }
      })
    },
    // 已确认查询
    JfgetStockConfirmedLists () {
      JfgetStockConfirmedList({
        pageNo: this.pageInfoT.pageNo,
        pageSize: this.pageInfoT.pageSize,
        primaryCustomerTaxId: this.formDataTwo.primaryCustomerTaxId,
        customerTaxId: this.formDataTwo.customerTaxId,
        instockNo: this.formDataTwo.instockNo,
        instockPlateNumber: this.formDataTwo.instockPlateNumber,
        productType: this.formDataTwo.productType,
        steelMillName: this.formDataTwo.steelMillName,
        specification: this.formDataTwo.specification,
        model: this.formDataTwo.model,
        inWarehouseNo: this.formDataTwo.inWarehouseNo,
        confirmTimeStart: this.formDataTwo.confirmTimeStart,
        confirmTimeEnd: this.formDataTwo.confirmTimeEnd,
        arrivalMethod: this.formDataTwo.arrivalMethod,
        plateNumber: this.formDataTwo.plateNumber
      })
        .then(res => {
          this.tableDataT = res.list
          this.totalT = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxunT () {
      this.JfgetStockConfirmedLists()
      this.getStockConfirmNumberJF()
    },
    chongzhiT () {
      this.formDataTwo.primaryCustomerTaxId = ''
      this.formDataTwo.customerTaxId = ''
      this.formDataTwo.instockNo = ''
      this.formDataTwo.instockPlateNumber = ''
      this.formDataTwo.productType = ''
      this.formDataTwo.steelMillName = ''
      this.formDataTwo.specification = ''
      this.formDataTwo.model = ''
      this.formDataTwo.inWarehouseNo = ''
      this.formDataTwo.confirmTimeStart = ''
      this.formDataTwo.confirmTimeEnd = ''
      this.formDataTwo.arrivalMethod = ''
      this.formDataTwo.plateNumber = ''
      this.JfgetStockConfirmedLists()
      this.getVirtualBalingList()
      this.getStockConfirmNumberJF()
    },
    daochuT () {
      exportExcel(
        this.global.wmsAccessName + '/instockThreadExp/exportStockConfirmedList', {
          ...this.formDataTwo,
          instockStatus: '1'
        },
        '已确认表'
      )
    },
    xiugaiT () {
      let a = []
      let c = []
      let b = 0
      this.selectList.forEach(item => {
        a.push(item.inWarehouseNo)
        c.push(item.stockConfirmId)
      })
      if (c.length !== 0) {
        this.stockConfirmIds = c.join(',')
      }
      for (var i = 0; i < a.length; i++) {
        if (a[i] !== a[0]) {
          b++
        }
      }
      if (b === 0) {
        this.XGDHvisible = true
        this.oldDH = this.selectList[0].inWarehouseNo
        this.$nextTick(() => {
          this.$refs.DHFormData.clearValidate()
        })
        this.DHFormData.modifyAfter = ''
      } else {
        DonMessage.error('进仓单号不一致，请重新选择!')
      }
    },

    // 修改单号
    XGDH () {
      this.addLoad = true
      this.$refs.DHFormData.validate((valid) => {
        if (valid) {
          JfmodifyStockConfirm({
            stockConfirmIds: this.stockConfirmIds,
            businessType: 2,
            modifyAfter: this.DHFormData.modifyAfter,
            modifyBefore: this.selectList[0].inWarehouseNo
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.addLoad = false
              this.JfgetStockConfirmedLists()
            })
            .catch((err) => {
              DonMessage.error(err.message)
              this.addLoad = false
            })
          this.XGDHvisible = false
        } else {
          this.addLoad = false
        }
      })
    },
    NumberInput (row) {
      this.$set(row, 'unpackingWeight', (row.unpackingNumber / 1 * row.singletonWeight / 1).toFixed(4))
    },
    // 点击拆包
    chaibao () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行拆包操作！')
      } else if (this.selectList[0].number == 1) {
        this.$message({
          message: '该货物不可进行拆包操作',
          type: 'error'
        })
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else {
        this.CBVisible = true
        this.CBLoading = false
        this.subTableData = JSON.parse(JSON.stringify(this.selectList))
        getWeighingMethodList({
          productType: this.selectList[0].productType
        })
          .then(res => {
            this.$set(this.subTableData[0], 'inWeighingMethod', res[0].inWeighingMethod)
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      }
    },
    // 保存拆包
    succeCB () {
      if (this.subTableData[0].unpackingNumber == undefined && this.subTableData[0].unpackingPoundWeight ==
          undefined) {
        DonMessage.error('请填写信息')
      } else if (this.subTableData[0].unpackingNumber >= this.selectList[0].number) {
        this.$message({
          message: '拆包件数不能大于等于总件数',
          type: 'error'
        })
        return
      } else if (this.subTableData[0].unpackingNumber == 0) {
        this.$message({
          message: '拆包件数不能为0',
          type: 'error'
        })
        return
      } else if (this.selectList[0].inWeighingMethod == 2 && this.subTableData[0].unpackingPoundWeight == undefined) {
        this.$message({
          message: '拆包磅重不能为空',
          type: 'error'
        })
        return
      } else if (this.selectList[0].inWeighingMethod == 2 && this.subTableData[0].unpackingPoundWeight == 0) {
        this.$message({
          message: '拆包磅重不能为零',
          type: 'error'
        })
        return
      } else if (this.subTableData[0].unpackingPoundWeight > this.selectList[0].poundWeight) {
        this.$message({
          message: '拆包磅重不能大于原过磅净重',
          type: 'error'
        })
        return
      } else if (this.selectList[0].inWeighingMethod == 3 && this.subTableData[0].unpackingFactoryPoundWeight ==
          undefined) {
        DonMessage.error('请填写拆包出厂过磅净重')
      } else if (this.selectList[0].inWeighingMethod == 3 && this.subTableData[0].unpackingFactoryPoundWeight == 0) {
        DonMessage.error('拆包出厂过磅净重不能为零')
      } else if (this.subTableData[0].unpackingFactoryPoundWeight >= this.selectList[0].allWeight) {
        DonMessage.error('拆包出厂过磅净重不能大于等于总重量')
      } else {
        this.CBLoading = true
        JfstockConfirmUnpacking({
          stockConfirmId: this.subTableData[0].stockConfirmId,
          unpackingWeight: this.subTableData[0].unpackingWeight,
          unpackingPoundWeight: this.subTableData[0].unpackingPoundWeight,
          unpackingNumber: this.subTableData[0].unpackingNumber,
          unpackingFactoryPoundWeight: this.subTableData[0].unpackingFactoryPoundWeight
        })
          .then(res => {
            this.CBVisible = false
            this.CBLoading = false
            this.chaxun()
            this.chaxunT()
            this.subTableData[0].unpackingWeight = ''
            this.subTableData[0].unpackingPoundWeight = ''
            this.subTableData[0].unpackingNumber = ''
            this.subTableData[0].unpackingFactoryPoundWeight = ''
          })
          .catch(error => {
            DonMessage.error(error.message)
            this.CBLoading = false
          })
      }
      this.CBLoading = false
    },
    // 关闭拆包
    closeCB () {
      this.CBVisible = false
      this.subTableData[0].unpackingWeight = ''
      this.subTableData[0].unpackingPoundWeight = ''
      this.subTableData[0].unpackingNumber = ''
      this.subTableData[0].unpackingFactoryPoundWeight = ''
    },
    // 修改记录
    editRecord (index, row) {
      this.XGJLVisible = true
      JfgetStorkConfirmedlList({
        businessId: row.stockConfirmId,
        businessType: 2
      })
        .then(res => {
          this.XGRecordData = res
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 修改记录关闭
    closeXGJL () {
      this.XGJLVisible = false
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetStockConfirmLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetStockConfirmLists()
    },
    handleCurrentChangeT (val) {
      this.pageInfoT.pageNo = val
      this.JfgetStockConfirmedLists()
    },
    handleSizeChangeT (val) {
      this.pageInfoT.pageSize = val
      this.JfgetStockConfirmedLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 合包
    hebao () {
      this.$confirm('确定合包吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        JfstockConfirmPacking({
          stockConfirmIds: this.selectListId
        })
          .then(res => {
            this.$message({
              message: '合包成功',
              type: 'success'
            })
            this.chaxun()
          })
          .catch(err => {
            this.$message({
              message: err.message,
              type: 'error'
            })
          })
      }).catch(() => {})
    },
    // 总吨数、总件数
    getStockConfirmNumberJF () {
      if (this.activeName == 'first') {
        let obj = {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          instockTimeStart: this.formData.instockTimeStart,
          instockTimeEnd: this.formData.instockTimeEnd,
          arrivalMethod: this.formData.arrivalMethod,
          plateNumber: this.formData.plateNumber,
          confirmStatus: '0'
        }
        jfGetStockConfirmNumber(obj).then(res => {
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        }).catch(error => {
          DonMessage.error(error.message)
        })
      } else {
        let obj2 = {
          pageNo: this.pageInfoT.pageNo,
          pageSize: this.pageInfoT.pageSize,
          primaryCustomerTaxId: this.formDataTwo.primaryCustomerTaxId,
          customerTaxId: this.formDataTwo.customerTaxId,
          instockNo: this.formDataTwo.instockNo,
          instockPlateNumber: this.formDataTwo.instockPlateNumber,
          productType: this.formDataTwo.productType,
          steelMillName: this.formDataTwo.steelMillName,
          specification: this.formDataTwo.specification,
          model: this.formDataTwo.model,
          inWarehouseNo: this.formDataTwo.inWarehouseNo,
          confirmTimeStart: this.formDataTwo.confirmTimeStart,
          confirmTimeEnd: this.formDataTwo.confirmTimeEnd,
          arrivalMethod: this.formDataTwo.arrivalMethod,
          plateNumber: this.formDataTwo.plateNumber,
          confirmStatus: '1'
        }
        jfGetStockConfirmNumber(obj2).then(res => {
          this.totalAllWeightB = res.totalAllWeight
          this.totalNumberB = res.totalNumber
        }).catch(error => {
          DonMessage.error(error.message)
        })
      }
    },
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = pH - h - 200 + 'px'
        let H = this.$refs.searchBoxT.offsetHeight
        let pHT = document.documentElement.clientHeight
        this.H = pHT - H - 200 + 'px'
      })
    }

  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJinCang')
    this.getRelationCustomerS()
    this.JfgetStockConfirmLists()
    this.JfgetStockConfirmedLists()
    this.getVirtualBalingList()
    this.getStockConfirmNumberJF()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.CBVisible == true) {
          // 拆包
          _this.succeCB()
        } else if (_this.XGvisible == true) {
          // 修改客户
          _this.XGQD()
        } else if (_this.dialogVisiblejincang == true) {
          // 进仓确认
          _this.jincangQR()
        } else if (_this.daoruMark == true) {
          // 导入
          _this.daoruQueding()
        } else if (_this.activeName == 'first') {
          _this.chaxun()
        } else if (_this.activeName == 'second') {
          _this.chaxunT()
        }
      }
    }
  },
  mounted () {
    this.getHeight()
  }
}

</script>

<style lang="less" scoped>
  .inpBox {
    .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

  /deep/.el-table th.star div::before {
    content: '*' !important;
    color: red !important;
  }
    .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

    /deep/.el-tabs__header{
  margin-bottom: 0;
}

</style>
